import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Ventures.module.css';
import Eyebrow from '../ui/Eyebrow';

const ventures = [
  {
    name: 'CMGT',
    role: 'COO',
    description: 'A Virginia-based consulting firm focused on change management and communications for federal government, private sector, and Fortune 500 clients. I run the operational and technical side. Angie Sanders, our CEO, leads organizational change strategy.',
    link: { label: 'cmgtfederal.com', href: 'https://cmgtfederal.com' },
    status: 'Active'
  },
  {
    name: 'Infundra',
    role: 'Founder',
    description: 'Infundra is an infrastructure-led venture platform deploying a single, production-grade stack across a focused portfolio of AI-native B2B companies.',
    link: { label: 'infundra.com', href: 'https://infundra.com' },
    status: 'Active'
  },
  {
    name: 'AgentDelta',
    role: 'Chief Architect, led development and design',
    description: 'AgentDelta is the modern OCM platform that blends human expertise with AI-driven signals to ensure your enterprise transformations succeed.',
    link: { label: 'agentdelta.ai', href: 'https://agentdelta.ai' },
    status: 'Active'
  },
  {
    name: 'eSolutions360',
    role: 'Founder',
    description: 'A web development firm I started in 2002. Still operating. Still building.',
    link: null,
    status: 'Active'
  }
];

export default function Ventures() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.ventures} id="ventures" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>Ventures</Eyebrow>
        <h2 className={styles.heading}>Current work.</h2>
        <div className={styles.grid}>
          {ventures.map((venture, i) => (
            <div key={i} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardName}>{venture.name}</h3>
                <span className={`${styles.badge} ${venture.status === 'Active' ? styles.badgeActive : styles.badgeDev}`}>
                  {venture.status}
                </span>
              </div>
              <div className={styles.cardRole}>{venture.role}</div>
              <p className={styles.cardDesc}>{venture.description}</p>
              {venture.link && (
                <a
                  href={venture.link.href}
                  target={venture.link.href.startsWith('http') ? '_blank' : undefined}
                  rel={venture.link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className={styles.cardLink}
                >
                  {venture.link.label} &rarr;
                </a>
              )}
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
